export const IMAGES_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL ||
  'https://shopping1.yettel.rs/feature1/partner/api/img/';
